import Badge from "../../components/ui/Badge";
import Field from "../../components/ui/Field";
import { formatDate } from "../../utils/date";
import { formatManilaDate, todayManilaKey } from "../../utils/manilaTime";
import { cx } from "../../utils/classNames";
import ui from "../../components/ui/ui.module.css";
import styles from "./MyAssets.module.css";

// One currently assigned asset, with the "I received this" action.
const AssetCard = ({ assignment, onAcknowledge }) => {
  const { asset } = assignment;
  const brandModel = [asset.brand, asset.model].filter(Boolean).join(" ");
  const isOverdue =
    !!assignment.expectedReturnDate &&
    assignment.expectedReturnDate < todayManilaKey();

  return (
    <div className={styles.assetCard}>
      <div className={styles.assetHeader}>
        <span className={styles.assetTag}>{asset.assetTag}</span>
        {asset.assetType && <Badge tone="blue">{asset.assetType.name}</Badge>}
      </div>

      <div>
        <div className={styles.assetName}>{asset.name}</div>
        {brandModel && <div className={ui.muted}>{brandModel}</div>}
      </div>

      <div className={styles.assetFields}>
        <Field label="Serial no.">{asset.serialNumber}</Field>
        <Field label="Assigned">
          {formatManilaDate(assignment.assignedAt)}
        </Field>
        {/* "YYYY-MM-DD" set by HR when you got the item. */}
        <Field label="Date received">
          {assignment.dateReceived ? formatDate(assignment.dateReceived) : null}
        </Field>
        {assignment.expectedReturnDate && (
          <Field label="Return by">
            <span className={cx(isOverdue && styles.overdue)}>
              {formatDate(assignment.expectedReturnDate)}
              {isOverdue && " · Overdue"}
            </span>
          </Field>
        )}
        <Field label="Handover condition">{assignment.conditionOut}</Field>
      </div>

      {assignment.assignNotes && (
        <p className={styles.notes}>{assignment.assignNotes}</p>
      )}

      <div className={styles.assetFooter}>
        {assignment.acknowledgedAt ? (
          <Badge tone="green" icon="bi-check-circle">
            Acknowledged {formatManilaDate(assignment.acknowledgedAt)}
          </Badge>
        ) : (
          <button
            type="button"
            className={cx(ui.button, ui.primary, ui.buttonSmall)}
            onClick={() => onAcknowledge(assignment)}
          >
            <i className="bi bi-box-seam"></i>I received this
          </button>
        )}
      </div>
    </div>
  );
};

export default AssetCard;
